import Vue from 'vue';

const EventBus = new Vue();
export default EventBus;

// Events:
// device-selector-modal-select-${this.busId}
// open-device-selector-modal
